import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby"
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

import { BLOCKS } from "@contentful/rich-text-types"
import { MARKS } from "@contentful/rich-text-types"
import { INLINES } from '@contentful/rich-text-types'
import { renderRichText } from "gatsby-source-contentful/rich-text"

import Container, { Row, TwoThird } from "../layout/container"
import Sidemenu from "../layout/sidebar";
import PublicRealm from "./public-realm";
import Yoo from "./yoo-capital";
import Ahmm from "./ahmm";
import Momentum from "./momentum";
import Spparc from "./spparc";
import ArrivingOnFoot from "./arriving-on-foot";
import Cycling from "./cycling";
import Tube from "./tube";

const Section = styled.section`
  background: ${(props) => props.theme.colors.white};
  padding: 3rem 0 3rem;
  h2 {
    //font-family: ${(props) => props.theme.fontBold};
    position: relative;
    margin-bottom: 0;
    text-transform: none;
  }
  aside {
    display: none;
    .future {
        opacity: 0.5;
    }
    .proposal {
        opacity: 0.5;
    }
    .collab {
        opacity: 0.5;
    }
    .about {
        opacity: 1;
    }
    .feedback {
        opacity: 0.5;
    }

    @media screen and (min-width: ${props => props.theme.breakpoints.tablet}) {
      display: block;
    }
  }
`;



const Button = styled(Link)`
    font-size: 1rem;
    padding: 1rem 0;
    text-align: center;
    margin: 1rem 0;
    border: 2px solid #00FFB4;
    color: #3C3C3B;
    -webkit-text-decoration: none;
    text-decoration: none;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    z-index: 3;
    position: relative;
    width: 100%;
  &:hover {
    background: transparent;
    border: 2px solid ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.white};
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 0.5rem 2rem;
    font-size: 1.5rem;
  }
`




const options: any = {
  renderMark: {
    [MARKS.CODE]: (embedded: any) => (
      <div dangerouslySetInnerHTML={{ __html: embedded }} />
    ),
  },
  renderNode: {
    "embedded-asset-block": (node) => {
      const alt = node.data.target.fields.title["en-GB"];
      const url = node.data.target.fields.file["en-GB"].url;
      return <img alt={alt} src={url} />;
    },
    [INLINES.HYPERLINK]: (node) => {
      return <a href={node.data.uri} target="_blank" rel="noopener noreferrer">{node.content[0].value}</a>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: (_node: any) => {
        const entry = _node.data.target


      },

  },
};


const Faqs = () => {
    const data = useStaticQuery(graphql`{
            contentfulVisiting {
                faq {
                    raw
                }
            }
        }
    `)
  return (
    <Section id="faq">
        <h2>
        FAQs
        </h2>
        {renderRichText(data.contentfulVisiting.faq, options)}
    </Section>
  );
};

export default Faqs